import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getBillTosDataView, getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import loadBillTos from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadBillTos";
import updateSearchFields from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/UpdateSearchFields";
import updateBillTosSearchFields from "@insite/client-framework/Store/Pages/RfqMyQuotes/Handlers/UpdateBillTosSearchFields";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import DynamicDropdown, { DynamicDropdownPresentationProps, OptionObject } from "@insite/mobius/DynamicDropdown";
import { FormInputWrapper } from "@insite/mobius/FormField";
import Select, { SelectProps } from "@insite/mobius/Select";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import debounce from "lodash/debounce";
import truncate from "lodash/truncate";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => {
    const { getBillTosParameter } = state.pages.rfqMyQuotes;
    return {
        // billTosDataView: getBillTosDataView(state, {}),
        billTosDataView: getBillTosParameter && getBillTosDataView(state, getBillTosParameter),
        parameter: state.pages.orderHistory.getOrdersParameter,
        contextBillTo: state.context.session.billToId,
        settings: getSettingsCollection(state),
        getBillTosParameter,
        billToState: getBillToState(state, state.context.session.billToId),
    };
};

const mapDispatchToProps = {
    updateSearchFields,
    loadBillTos,
    updateBillTosSearchFields,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface OrderHistorySearchFieldShipToStyles {
    select?: SelectProps;
    wrapper?: InjectableCss;
    optionText?: TypographyPresentationProps;
    lookbackPeriodMessage?: InjectableCss;
    selectDropdownStyle?: InjectableCss;
    billToSelectorDynamicDropdown?: DynamicDropdownPresentationProps;
}

export const shipToStyles: OrderHistorySearchFieldShipToStyles = {
    wrapper: {
        css: css`
            width: 100%;
            padding: 1.5rem;
            background-color: #f1f1f1;
        `,
    },
    select: {
        cssOverrides: {
            formField: css`
                label {
                    width: 200px;
                }
                ${FormInputWrapper} {
                    max-width: 360px;
                    option {
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        max-width: 360px;
                    }
                }
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                flex-direction: column;
                                label {
                                    width: 100%;
                                    text-align: left;
                                }
                                ${FormInputWrapper} {
                                    max-width: 360px;
                                    width: 100%;
                                }
                            `,
                            css`
                                flex-direction: column;
                                label {
                                    width: 100%;
                                    text-align: left;
                                }
                                ${FormInputWrapper} {
                                    max-width: 360px;
                                    width: 100%;
                                }
                            `,
                            null,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
            `,
        },
    },
    optionText: {
        ellipsis: true,
        css: css`
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 360px;
        `,
    },
    lookbackPeriodMessage: {
        css: css`
            margin: 15px 30px;
            width: 50%;
            float: right;
        `,
    },
    selectDropdownStyle: {
        css: css`
            width: 50%;
            float: left;
        `,
    },
};
const styles = shipToStyles;

// class OrderHistorySearchFieldBillTo extends React.Component<Props> {
//     state = {
//         defaulSelectValue: -1,
//     };

//     componentDidMount() {
//         if (!this.props.billTosDataView.value) {
//             this.props.loadBillTos();
//         }

//         setTimeout(() => {
//             const billToOptions = this.props.billTosDataView.value || [];
//             const billToId = this.props.contextBillTo.billToId;
//             const extractingCurrentId = billToOptions.find(val => {
//                 return val.id === billToId;
//             });
//             const defaultVal = extractingCurrentId ? extractingCurrentId.customerNumber : undefined;
//             this.setState({ defaulSelectValue: defaultVal });
//             this.props.updateSearchFields({ customerNumber: defaultVal } as GetOrdersApiParameter);
//         }, 2000);
//     }

//     selectCustomerHandler = (billToId?: string) => {
//         this.props.updateSearchFields({ customerNumber: billToId } as GetOrdersApiParameter);
//     };

//     render() {
//         const billToOptions = this.props.billTosDataView.value || [];
//         // const billToId = this.props.contextBillTo.billToId;
//         // const extractingCurrentId = billToOptions.find((val)=>{
//         //     return val.id === billToId;
//         // });
//         // const defaultValue = extractingCurrentId ? extractingCurrentId.customerNumber : -1;
//         const months: number = this.props.settings.orderSettings.lookBackDays / 30;
//         const lookbackMessage = siteMessage("lookback_message", `${months}`);
//         const options: OptionObject[] = [
//             {
//                 optionText: "All",
//                 optionValue: "-1",
//             },
//             ...billToOptions.map(billTo => ({
//                 optionText: billTo.label,
//                 optionValue: billTo.,customerNumber
//             })),
//         ];

//         return (
//             <StyledWrapper {...styles.wrapper}>
//                 <StyledWrapper
//                     css={css`
//                         width: 100%;
//                         max-width: 1440px;
//                         margin: 0 auto;
//                         display: flex;
//                     `}
//                 >
//                     <StyledWrapper {...styles.selectDropdownStyle}>
//                         <DynamicDropdown
//                             label={translate("Select Customer Account")}
//                             {...styles.billToSelectorDynamicDropdown}
//                             onSelectionChange={this.selectCustomerHandler}
//                             selected={(this.props.parameter as any).customerNumber || this.state.defaulSelectValue}
//                             options={options}
//                             placeholder={translate("Search or Select Bill To")}
//                             data-test-selector="changeCustomerBillToSelectorOrderHistory"
//                             filterOption={() => true}
//                         />
//                     </StyledWrapper>
//                     <StyledWrapper {...styles.lookbackPeriodMessage}>{lookbackMessage}</StyledWrapper>
//                 </StyledWrapper>
//             </StyledWrapper>
//         );
//     }
// }

const OrderHistorySearchFieldBillTo = ({
    billTosDataView,
    getBillTosParameter,
    loadBillTos,
    updateBillTosSearchFields,
    updateSearchFields,
    settings,
    contextBillTo,
    billToState,
    parameter,
}: Props) => {
    const [billToOptions, setBillToOptions] = React.useState<OptionObject[]>([]);
    const [billToSearch, setBillToSearch] = React.useState("");
    const EMTPY_ID = "-1";
    const months: number = settings.orderSettings.lookBackDays / 30;
    const lookbackMessage = siteMessage("lookback_message", `${months}`);

    React.useEffect(() => {
        if (!(parameter as any).customerNumber) {
            loadBillTos(getBillTosParameter);
        }
    }, [parameter]);

    React.useEffect(() => {
        if (billTosDataView?.value) {
            const billToOptions = getBillToOptions();
            setBillToOptions(billToOptions);
        } else if (billTosDataView && !billTosDataView.value && !billTosDataView.isLoading) {
            loadBillTos(getBillTosParameter);
        }
    }, [billTosDataView]);

    React.useEffect(() => {
        if (billToState.value) {
            updateSearchFields({
                customerNumber:
                    billToState.value.customerNumber === EMTPY_ID || !billToState.value.customerNumber
                        ? EMTPY_ID
                        : billToState.value.customerNumber,
            } as GetOrdersApiParameter);
        }
    }, [billToState]);

    const changeCustomerSearchTextHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.currentTarget.value;
        setBillToSearch(value);
        debouncedUpdateBillTosSearchFields(value);
    };

    const debouncedUpdateBillTosSearchFields = debounce((value: string) => {
        updateBillTosSearchFields({ ...getBillTosParameter, filter: value || undefined });
    }, 200);

    const selectCustomerHandler = (customerId?: string) => {
        updateSearchFields({
            customerNumber: customerId === EMTPY_ID ? EMTPY_ID : customerId,
        } as GetOrdersApiParameter);

        //  updateSearchFields({ customerNumber: customerId } as GetOrdersApiParameter);
    };

    const getBillToOptions = () => {
        const options: OptionObject[] =
            billTosDataView?.value?.map(billTo => ({
                optionText: billTo.label,
                optionValue: billTo.customerNumber,
            })) || [];
        options.unshift({ optionText: translate("Show All"), optionValue: EMTPY_ID });

        return options;
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper
                css={css`
                    width: 100%;
                    max-width: 1440px;
                    margin: 0 auto;
                    display: flex;
                `}
            >
                <StyledWrapper {...styles.selectDropdownStyle}>
                    <DynamicDropdown
                        label={translate("Select Customer Account")}
                        {...styles.billToSelectorDynamicDropdown}
                        onSelectionChange={selectCustomerHandler}
                        onInputChange={changeCustomerSearchTextHandler}
                        selected={(parameter as any).customerNumber || EMTPY_ID}
                        isLoading={billTosDataView?.isLoading}
                        options={billToOptions}
                        search={billToSearch}
                        data-test-selector="changeCustomerBillToSelectorOrderHistory"
                        placeholder={translate("Search or Select Bill To")}
                        filterOption={() => true}
                    />
                </StyledWrapper>
                <StyledWrapper {...styles.lookbackPeriodMessage}>{lookbackMessage}</StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(OrderHistorySearchFieldBillTo),
    definition: {
        group: "Order History",
        displayName: "Order History Bill To",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
    },
};

export default widgetModule;
